import React from 'react';
import { Card } from 'react-bootstrap';
import Plot from 'react-plotly.js';
import { Calendar } from 'lucide-react';

const SeasonalityChart = ({ chartData }) => {
  if (!chartData) return null;

  try {
    const plotData = JSON.parse(chartData);
    
    return (
      <Card>
        <Card.Header>
          <h5 className="card-title mb-0 d-flex align-items-center">
            <Calendar className="text-success me-2" size={20} />
            Monthly Seasonality Patterns
          </h5>
        </Card.Header>
        <Card.Body>
          <div className="chart-container">
            <Plot
              data={plotData.data}
              layout={{
                ...plotData.layout,
                autosize: true,
                responsive: true,
              }}
              config={{
                responsive: true,
                displayModeBar: true,
                displaylogo: false,
                modeBarButtonsToRemove: ['pan2d', 'lasso2d', 'select2d']
              }}
              style={{ width: '100%', height: '400px' }}
            />
          </div>
        </Card.Body>
      </Card>
    );
  } catch (error) {
    console.error('Error rendering seasonality chart:', error);
    return (
      <Card>
        <Card.Header>
          <h5 className="card-title mb-0">
            <Calendar className="text-success me-2" size={20} />
            Monthly Seasonality Patterns
          </h5>
        </Card.Header>
        <Card.Body>
          <div className="alert alert-danger">
            Error loading seasonality chart. Please try refreshing the page.
          </div>
        </Card.Body>
      </Card>
    );
  }
};

export default SeasonalityChart;